import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MaterialPaper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
export const Container = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(-2),
    minHeight: 'calc(100vh - 152px)',
    marginBottom: theme.spacing(-5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
}));
export const Paper = styled((props) => _jsx(MaterialPaper, Object.assign({}, props, { elevation: 0 })))(({ theme }) => ({
    borderRadius: 0,
    width: '100%',
    maxWidth: 450,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
}));
export const Header = styled((props) => _jsx(Typography, Object.assign({}, props, { variant: 'h6' })))(({ theme }) => {
    var _a;
    return ({
        marginBottom: theme.spacing(2),
        fontWeight: 800,
        color: (_a = theme.account) === null || _a === void 0 ? void 0 : _a.page.heading,
    });
});
export const SubHeader = styled((props) => _jsx(Typography, Object.assign({}, props)))(({ theme }) => {
    var _a;
    return ({
        fontWeight: 600,
        color: (_a = theme.account) === null || _a === void 0 ? void 0 : _a.page.subHeading,
    });
});
